import axios from 'axios';

// Create an instance with your PHP backend base URL
const axiosInstance = axios.create({
    baseURL: 'https://backendibos.aartiassociates.com/',
    headers: {
        'Content-Type': 'application/json',
    },
});

// --- 1. REQUEST INTERCEPTOR ---
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            // Inject the JWT into every outgoing request
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Log the request for your Audit Log system
        // console.log(`[API Request]: ${config.method.toUpperCase()} ${config.url}`);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// --- 2. RESPONSE INTERCEPTOR ---
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const { config, response } = error;

        // Check if the failed request was the LOGIN request
        const isLoginRequest = config.url.includes('login.php');

        if (response && response.status === 401 && !isLoginRequest) {
            // ONLY redirect if it's NOT the login page failing
            console.warn('Session expired. Redirecting...');
            localStorage.removeItem('token');
            localStorage.removeItem('user_session');
            window.location.href = '/login';
        }
        if (error.response && error.response.status === 402) {
            // Clear local storage/tokens
            localStorage.clear();
            // Redirect to a specific route or show a global alert
            window.location.href = "/subscription-expired";
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;